import axios from 'axios';

export default function sendCounter(url) {

   axios.get(url)
        .then(function () {
            return true
        })
        .catch(function () {
            return false
        })

}

